import instructIcon from '../../../assets/instruct-icon.svg';
import instructMockup from '../../../assets/instruct-image.png';
import manageIcon from '../../../assets/manage-icon.svg';
import manageMockup from '../../../assets/manage-image.png';
import trainIcon from '../../../assets/train-icon.svg';
import trainMockup from '../../../assets/train-image.png';
import { CarouselTab } from '../LandingCarousel.types';
import { CarouselContentConfig } from './LandingCarouselContent.types';

export const CAROUSEL_CONTENT: Record<CarouselTab, CarouselContentConfig> = {
  manage: {
    moduleLabelKey: 'landingPage.carousel.manage.label',
    titleKey: 'landingPage.carousel.manage.title',
    bulletKeys: [
      'landingPage.carousel.manage.bullet1',
      'landingPage.carousel.manage.bullet2',
      'landingPage.carousel.manage.bullet3',
      'landingPage.carousel.manage.bullet4',
    ],
    imageSrc: manageMockup,
    imageAltKey: 'landingPage.carousel.manage.imageAlt',
    iconSrc: manageIcon,
    moduleContact: 'landingPage.carousel.manage.interestedInKnowingMore',
    moduleContactMore: 'landingPage.carousel.manage.reactOutToYourAccountExecutive',
  },
  train: {
    moduleLabelKey: 'landingPage.carousel.train.label',
    titleKey: 'landingPage.carousel.train.title',
    bulletKeys: [
      'landingPage.carousel.train.bullet1',
      'landingPage.carousel.train.bullet2',
      'landingPage.carousel.train.bullet3',
      'landingPage.carousel.train.bullet4',
    ],
    imageSrc: trainMockup,
    imageAltKey: 'landingPage.carousel.train.imageAlt',
    iconSrc: trainIcon,
    moduleContact: 'landingPage.carousel.train.havingTrouble',
    moduleContactMore: 'landingPage.carousel.train.contactCustomerSupport',
    moduleLabelDescriptionKey: 'landingPage.carousel.train.labelDescription',
    alsoAvailableInIOS: 'landingPage.carousel.train.alsoAvailable',
    availableSoon: 'landingPage.carousel.train.availableSoon',
    goToCrewTraining: 'landingPage.carousel.train.goToCrewTraining',
  },
  instruct: {
    moduleLabelKey: 'landingPage.carousel.instruct.label',
    titleKey: 'landingPage.carousel.instruct.title',
    bulletKeys: [
      'landingPage.carousel.instruct.bullet1',
      'landingPage.carousel.instruct.bullet2',
      'landingPage.carousel.instruct.bullet3',
    ],
    imageSrc: instructMockup,
    imageAltKey: 'landingPage.carousel.instruct.imageAlt',
    iconSrc: instructIcon,
  },
};

export function handleOpenCrewTraining(): void {
  window.open(import.meta.env.VITE_CREWTRAINING_URL, '_blank', 'noopener,noreferrer');
}
